module.exports = __webpack_public_path__ + "fonts/STKBureauSans-Medium.b4fe77fbefc61bfe027f860d9667941c.eot";